module.exports = __webpack_public_path__ + "static/8-60e53e550054c8f531af74c9b0a88715.jpg";